import React from 'react';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from '../../hooks/ThemeProvider';
import './DarkModeToggle.scss';

interface DarkModeToggleProps extends Omit<IconButtonProps, 'onClick'> {
  showTooltip?: boolean;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const DarkModeToggle: React.FC<DarkModeToggleProps> = ({
  showTooltip = true,
  tooltipPlacement = 'bottom',
  className = '',
  ...rest
}) => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  const button = (
    <IconButton
      onClick={toggleDarkMode}
      color="inherit"
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`dark-mode-toggle ${className}`}
      {...rest}
    >
      {isDarkMode ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  );

  if (showTooltip) {
    return (
      <Tooltip
        title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        placement={tooltipPlacement}
      >
        {button}
      </Tooltip>
    );
  }

  return button;
};
